import { render, staticRenderFns } from "./Cliente.vue?vue&type=template&id=63ce6cd9"
import script from "./Cliente.vue?vue&type=script&lang=js"
export * from "./Cliente.vue?vue&type=script&lang=js"
import style0 from "./Cliente.vue?vue&type=style&index=0&id=63ce6cd9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports